import { createReducer } from '@reduxjs/toolkit';

import initialState from './transactions.initialState';
import { ACTION_TYPES } from './transactions.constant';

const handleResetState = () => initialState;

const handleFetchStart = (state) => {
  state.loading = true;
};

const handleFetchError = (state, action) => {
  state.loading = false;
  state.error = [true, action.payload];
};

const handleFetchSuccess = (state, action) => {
  state.loading = false;
  state.data = action.payload;
  state.error = [false, null];
};

const handleUpdateCurrent = (state, action) => {
  state.current = action.payload;
};

export default createReducer(initialState, {
  [ACTION_TYPES.RESET.STATE]: handleResetState,
  [ACTION_TYPES.FETCH.START]: handleFetchStart,
  [ACTION_TYPES.FETCH.ERROR]: handleFetchError,
  [ACTION_TYPES.FETCH.SUCCESS]: handleFetchSuccess,
  [ACTION_TYPES.UPDATE.CURRENT]: handleUpdateCurrent,
});
